import AV from "leancloud-storage"; 
class Question extends AV.Object {
  get license() {
    return this.get('license');
  }
  set license(value) {
    this.set('license', value);
  }


  get templateType() {
    return this.get('templateType');
  }
  set templateType(value) {
    this.set('templateType', value);
  }

  get gradeClassify() {
    return this.get('gradeClassify');
  }
  set gradeClassify(value) {
    this.set('gradeClassify', value);
  }
  get keywords() {
    return this.get('keywords');
  }
  set keywords(value) {
    this.set('keywords', value);
  }
  

   get questionData() {
    return this.get('questionData');
  }
  set questionData(value) {
    this.set('questionData', value);
  }
  
   get answerType() {
    return this.get('answerType');
  }
  set answerType(value) {
    this.set('answerType', value);
  }

 


  
   get answerSelection() {
    return this.get('answerSelection');
  }
  set answerSelection(value) {
    this.set('answerSelection', value);
  }


   get standardAnswerText() {
    return this.get('standardAnswerText');
  }
  set standardAnswerText(value) {
    this.set('standardAnswerText', value);
  }
  


   get questionType() {
    return this.get('questionType');
  }
  set questionType(value) {
    this.set('questionType', value);
  }
 

   get grade() {
    return this.get('grade');
  }
  set grade(value) {
    this.set('grade', value);
  }

  get tags() {
    return this.get('tags');
  }
  set tags(value) {
    this.set('tags', value);
  }

}
AV.Object.register(Question, 'NJQuestion');
export default Question